import type { AbilityChargeSnapshot } from '../../../shared/combat/AbilityChargeWire';
import { CooldownStore } from '../../systems/player/CooldownStore';

/** Called outside React state updaters: resource settlement is exactly once. */
export function applyChargeMessage(message: unknown): void {
  if (!message || typeof message !== 'object' || Array.isArray(message)) return;
  if ('version' in message) {
    CooldownStore.applyChargeSnapshot(message as AbilityChargeSnapshot);
    return;
  }
  // Older snapshot producers have no transaction receipts. They may refresh
  // state but cannot retire a pending cast or reset owner lifecycle.
  CooldownStore.hydrateFullCharges(message as Record<string, unknown>);
}
